import { cx, styled } from "simplydo/react/styled";

import type { ListHeaderProps } from "./List.types";

const HeaderEl = styled.div`
  font-weight: bold;
  color: rgba(0, 0, 0, 0.87);
`;

const ListHeaderComponent = (props: ListHeaderProps) => {
  const { children, className, style } = props;
  return (
    <HeaderEl className={cx(className)} style={style}>
      {children}
    </HeaderEl>
  );
};

export const ListHeader = styled(ListHeaderComponent)``;
